import { BaseApiManager, ApiResponse } from './BaseApiManager';

export class VisualizationApiManager extends BaseApiManager {
  private static instance: VisualizationApiManager;

  private constructor() {
    super();
  }

  public static getInstance(): VisualizationApiManager {
    if (!VisualizationApiManager.instance) {
      VisualizationApiManager.instance = new VisualizationApiManager();
    }
    return VisualizationApiManager.instance;
  }

  public async getVisualizationTranscripts(
    userId: string, 
    sessionId: string, 
    truncate: boolean = false
  ): Promise<ApiResponse<any>> {
    const url = `/core/audio-history/users/${userId}/sessions/${sessionId}/transcripts${truncate ? '?truncate=true' : ''}`;
    return this.request(url);
  }
}
